// Filename: uipageselect.js
// Timestamp: 2018.01.16-00:41:55 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>
//
// roughly follows this design:
//
//   https://labs.daemon.com.au/uploads/default/50/b97f1a9e03a7661a.png
//
//   < 『1』「2」「3」「4」...「8」>
//

const getprevnum = (uinum, minnum = 1) => uinum - Number(uinum > minnum)
const getnextnum = (uinum, maxnum) => uinum + Number(uinum < maxnum)

const xvnode = (ss, cfg, gr, nd, pg, subj) => {
  const div = cfg.h.div(nd)
  const { a, i, span } = cfg.h
  const {
    pgnum,
    pgtotal,
    hreftpl,
    hreffirstpage,
    labelprimarytpl
  } = subj
  const pgnumm = Number(pgnum)
  const isstartlinkactive = pgnumm === 1
  const isendlinkactive = pgnumm === pgtotal
  const prevnum = getprevnum(pgnumm, 1)
  const nextnum = getnextnum(pgnumm, pgtotal)

  return (
    div('ui:', [
      isstartlinkactive
        ? span('previous')
        : a({href: prevnum === 1 && hreffirstpage
          ? hreffirstpage
          : hreftpl.replace(/:pgnum/, prevnum)}, 'previous'),
      i(labelprimarytpl
        .replace(/:pgnum/, pgnumm)
        .replace(/:pgtotal/, pgtotal)),
      isendlinkactive
        ? span('next')
        : a({href: hreftpl.replace(/:pgnum/, nextnum) }, 'next')
    ])
  )
}

export default {
  type: 'uipageselect',
  xvnode
}
